import urljoin from 'url-join';

const {
    REACT_APP_URL_STORAGE,
    REACT_APP_URL_IMAGE,
} = process.env;


export const resolveImageUrl = (relativeUrl, width) => {
    if (width) {
        return urljoin(REACT_APP_URL_IMAGE, String(width), relativeUrl);
    }
    return urljoin(REACT_APP_URL_IMAGE, relativeUrl);
};

export const resolveStorageUrl = relativeUrl => {
    return urljoin(REACT_APP_URL_STORAGE, relativeUrl);
};



// WEBPACK FOOTER //
// ./src/utils/Storage.js